import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { css } from '@emotion/react';
import { gsap, ScrollTrigger } from 'gsap/all';
import { fullHeight, useHsHeader } from '../../util/hsHeader';
import FullScreenVideo from '../FullScreenVideo';
import { useDeviceSize } from '../../util/useDeviceSize';
import { useStory } from '../StoryContent';
import VideoMobile from '../VideoMobile';

gsap.registerPlugin(ScrollTrigger);

export default function VideoSlide7({ video, images }) {
  const [{ headerHeight }] = useHsHeader();
  const { toggleVideo } = useStory();
  const { isWideScreen } = useDeviceSize();

  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const videoTriggerRef = useRef();
  const imagesRef = useRef();

  useEffect(() => {
    if (!isWideScreen) {
      return undefined;
    }

    const tl = gsap
      .timeline()

      .to(videoTriggerRef.current, {
        duration: 0.2,
        opacity: 1,
        ease: 'ease-in',
      })
      .add(() => {
        setIsVideoPlaying(v => !v);
      })
      .to(videoTriggerRef.current, {
        duration: 0.4,
      })
      .add(() => {
        setIsVideoPlaying(v => !v);
      })
      .to(imagesRef.current, {
        duration: 0.2,
        opacity: 1,
      })
      .to(imagesRef.current, {
        duration: 0.05,
        x: '-25%',
      })
      .to(videoTriggerRef.current, {
        duration: 0.2,
        x: '-100%',
      });

    const st = ScrollTrigger.create({
      animation: tl,
      trigger: videoTriggerRef.current,
      pin: true,
      pinSpacing: false,
      scrub: true,
      start: 'top top',
      end: `bottom 0`,
      anticipatePin: 1,
      onToggle: ({ isActive }) => {
        videoTriggerRef.current.style.pointerEvents = isActive
          ? 'auto'
          : 'none';
      },
    });

    return () => {
      tl.kill();
      st.kill();
    };
  }, [headerHeight, toggleVideo, video, isWideScreen]);

  return isWideScreen ? (
    <div
      css={css`
        ${fullHeight(4)};
        position: relative;
        z-index: 2;
        opacity: 0;
        transform: translateY(-100vh);
        pointer-events: none;
      `}
      ref={videoTriggerRef}
    >
      <FullScreenVideo videoId={video.id} pause={!isVideoPlaying} />
      <div
        ref={imagesRef}
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          ${fullHeight()}
          display: flex;
          margin-top: 5vh;
          pointer-events: none;
          opacity: 0;
        `}
      >
        <div
          css={css`
            width: 50%;
            height: 90vh;
            text-align: right;
            margin-right: 8px;
          `}
        >
          <img
            src={images[0].src}
            css={css`
              height: 100%;
            `}
            alt=""
          />
        </div>
        <div
          css={css`
            width: 50%;
            height: 90vh;
            margin-left: 8px;
          `}
        >
          <img
            src={images[1].src}
            css={css`
              height: 50%;
            `}
            alt=""
          />
        </div>
      </div>
    </div>
  ) : (
    <VideoMobile videoId={video.id} />
  );
}

VideoSlide7.propTypes = {
  video: PropTypes.shape({ id: PropTypes.number }),
  images: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string })),
};

VideoSlide7.defaultProps = {
  video: null,
  images: null,
};
